import { StyleType } from "@iventis/domain-model/model/styleType";
import { StyleValue } from "@iventis/domain-model/model/styleValue";
import { Content } from "@iventis/translations/content/typed-content";
import { createStaticStyleValue } from "@iventis/layer-style-helpers";
import React, { FunctionComponent } from "react";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { AreaStyles } from "@iventis/map-engine/src/utilities/style-helpers";
import { selectItemsComponentCreator } from "@iventis/components";
import { AreaDimension } from "@iventis/domain-model/model/areaDimension";
import { AreaStyle } from "@iventis/domain-model/model/areaStyle";
import { AreaModelStyle } from "@iventis/domain-model/model/areaModelStyle";
import { EditStyleItemComponent } from "./edit-style-item";
import StyleContainer from "./style-container";
import { EditStyleProps } from "./style.types";
import { ChangeStyleValue } from "./edit-style.helpers";
import { StyledStyleItemContainer } from "./line-edit-style";
import { AreaEditStyleComponent } from "./area-edit-style";
import { AreaModelEditStyleComponent } from "./area-model-edit-style";

export const AreaEditStyleDelegator: FunctionComponent<
    {
        onStyleTypeChanged: (styleType: StyleType) => void;
    } & EditStyleProps<AreaStyles & { dimension?: AreaStyle["dimension"] }>
> = ({ layerStyle, onStyleTypeChanged, changeStyleValue, dataFields }) => {
    const translate = useIventisTranslate();
    const changeStyleTypeValue: ChangeStyleValue<AreaStyles & { dimension?: AreaStyle["dimension"] }> = (_, value) => {
        if (layerStyle.styleType === StyleType.Area) {
            if ((value as StyleValue<StyleType>)?.staticValue?.staticValue === StyleType.AreaModel) {
                onStyleTypeChanged(StyleType.AreaModel);
            } else {
                changeStyleValue("dimension", value as StyleValue<AreaDimension>);
            }
        }
        if (layerStyle.styleType === StyleType.AreaModel && Object.values(AreaDimension).includes((value as StyleValue<AreaDimension>).staticValue.staticValue)) {
            onStyleTypeChanged(StyleType.Area);
            changeStyleValue("dimension", value as StyleValue<AreaDimension>);
        }
    };
    return (
        <>
            <StyleContainer title={translate(Content.map2.styles.type_of_area)}>
                <StyledStyleItemContainer>
                    <EditStyleItemComponent
                        styleProperty={layerStyle.styleType === StyleType.Area ? "dimension" : "styleType"}
                        component={selectItemsComponentCreator({
                            testId: "style-type-selector",
                            options: [
                                { id: AreaDimension.Two, name: translate(Content.map2.styles.area_2d) },
                                { id: AreaDimension.Three, name: translate(Content.map2.styles.area_3d) },
                                { id: StyleType.AreaModel, name: translate(Content.map2.styles2[StyleType.AreaModel]) },
                            ],
                        })}
                        value={layerStyle.styleType === StyleType.Area ? layerStyle.dimension : createStaticStyleValue(StyleType.AreaModel)}
                        changeStyleValue={changeStyleTypeValue}
                        ignoreTitle
                    />
                </StyledStyleItemContainer>
            </StyleContainer>
            {layerStyle.styleType === StyleType.Area && <AreaEditStyleComponent layerStyle={layerStyle as AreaStyle} changeStyleValue={changeStyleValue} dataFields={dataFields} />}
            {layerStyle.styleType === StyleType.AreaModel && (
                <AreaModelEditStyleComponent layerStyle={layerStyle as AreaModelStyle} changeStyleValue={changeStyleValue} dataFields={dataFields} />
            )}
        </>
    );
};
